// src/pages/projects/ProjectTasksPage.jsx
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { Box } from '@mui/material';
import ProjectTaskList from '../../components/projects/ProjectTaskList';

/**
 * ProjectTasksPage - Container component for the project tasks list view
 * Uses the ProjectTaskList component within the ProjectContainer
 */
const ProjectTasksPage = () => {
  const { project, canEdit } = useOutletContext();
  
  if (!project) return null;
  
  return (
    <Box sx={{ height: '100%' }}>
      <ProjectTaskList 
        projectId={project._id} 
        canEdit={canEdit} 
      />
    </Box>
  );
};

export default ProjectTasksPage;